import React, { useMemo } from 'react';
import { WbsTaskSearchResult } from 'graphql/types';
import HierarchyOptionItem from './HierarchyOptionItem';

type RenderOptionProps = {
  searchText?: string | undefined;
  option: WbsTaskSearchResult;
};

const RenderOption = ({
  option,
  searchText
}: RenderOptionProps): React.ReactElement => {
  const hierarchyLevel = useMemo(
    () => (searchText ? 0 : option.parents.length),
    [searchText, option]
  );
  const fullPath = useMemo(
    () => option.parents.map(({ displayText }) => displayText),
    [option]
  );

  return (
    <HierarchyOptionItem
      hierarchyLevel={hierarchyLevel}
      showFullPath={Boolean(searchText)}
      fullPath={fullPath}
      title={option.displayText}
    />
  );
};

export default RenderOption;
